import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import VolumeControl from "./components/VolumeControl";
import { AuthProvider, useAuth } from "./lib/auth";
import Home from "./pages/Home";
import SoloSetup from "./pages/SoloSetup";
import SoloPlay from "./pages/SoloPlay";
import SoloResults from "./pages/SoloResults";
import MultiHub from "./pages/MultiHub";
import Join from "./pages/Join";
import Lobby from "./pages/Lobby";
import Account from "./pages/Account";
import AdminLogin from "./pages/admin/Login";
import AdminHome from "./pages/admin/Home";

function Shell() {
  const loc = useLocation();
  const { user, logout } = useAuth();
  const hideNav = loc.pathname.startsWith("/solo/play") || loc.pathname.startsWith("/j/");
  const wide = loc.pathname.startsWith("/admin");
  const home = loc.pathname === "/";
  return (
    <div className={`min-h-dvh flex flex-col ${hideNav ? "h-dvh overflow-hidden" : ""}`}>
      <header className="shrink-0 sticky top-0 z-50 border-b border-cream/10 bg-ink/90 backdrop-blur-md">
        <div className={`py-2 flex items-center gap-3 mx-auto w-full ${wide ? "px-2 max-w-none" : home ? "px-4 max-w-6xl" : hideNav ? "px-2 max-w-5xl" : "px-4 max-w-5xl"}`}>
          <Link to="/" className="font-display text-xl sm:text-2xl tracking-tight text-gold shrink-0">
            PGSet
          </Link>
          {!hideNav && (
            <nav className="flex gap-3 text-sm">
              <Link className="hover:text-gold" to="/solo">
                Solo
              </Link>
              <Link className="hover:text-gold" to="/multi">
                Salon
              </Link>
              {user?.isAdmin && (
                <Link className="hover:text-gold" to="/admin">
                  Atelier
                </Link>
              )}
            </nav>
          )}
          <div className="ml-auto flex items-center gap-2 sm:gap-3 min-w-0">
            {!hideNav &&
              (user ? (
                <>
                  <Link to="/compte" className="text-sm truncate max-w-[7rem] sm:max-w-[10rem] hover:text-gold">
                    {user.username}
                  </Link>
                  <button type="button" className="text-sm opacity-80 hover:text-gold shrink-0" onClick={() => void logout()}>
                    Sortir
                  </button>
                </>
              ) : (
                <Link to="/compte" className="text-sm hover:text-gold shrink-0">
                  Connexion
                </Link>
              ))}
            <VolumeControl />
          </div>
        </div>
      </header>
      <main
        className={`flex-1 w-full mx-auto ${hideNav ? "min-h-0 flex flex-col overflow-hidden pb-1 px-2 max-w-5xl" : "pb-10"} ${
          hideNav ? "" : wide ? "px-2 max-w-none" : home ? "px-4 max-w-6xl" : "px-4 max-w-5xl"
        }`}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solo" element={<SoloSetup />} />
          <Route path="/solo/play" element={<SoloPlay />} />
          <Route path="/solo/results" element={<SoloResults />} />
          <Route path="/multi" element={<MultiHub />} />
          <Route path="/join" element={<Join />} />
          <Route path="/j/:code" element={<Lobby />} />
          <Route path="/compte" element={<Account />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminHome />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
